//@flow

import type {Observable} from 'rgs-knockout';
import Switchers from 'rgs-nfd-ui-kit/ko-components/switchers/switchers';
import type {SwitcherArgs} from './../switchers';

export type SwitcherDoubleArgs = {|
	...SwitcherArgs,
	current: Observable<string>,
	firstLeft: { htmlContent: string, iconCss: Object },
	secondRight: { htmlContent: string, iconCss: Object },
	switcherCssRules: (number) => { css: Object }
|}


export default class SwitcherDouble extends Switchers {

	constructor (props: SwitcherDoubleArgs) {
		super(props);

		const [first, second] = this.props.items.peek();

		this.first = first;
		this.second = second;

		this.props = {
			...(this.props || {}),

			firstLeft: this.first,
			secondRight: this.second,

			switcherCssRules: (item: number) => {
				const isSelected = this.isItemActive(item);

				return {
					'nfd-switcher-item-active': isSelected,
					'nfd-switcher-item-hovered': !isSelected,
				};
			},
		};
	}
}
